import { ReferenceDocumentDTO } from '@reposit/api-client';
import moment from 'moment';
import React from 'react';
import { truncateFilename } from '../../utils/common.utils';
import IdentifierValue from '../IdentifierValue';
import RepositCard from '../Reposit/RepositCard';
import { Table, Tbody, Td, Thead, Tr } from '../Table';
import { A } from '../Typography';

interface ReferenceDocumentsProps {
  documents: ReferenceDocumentDTO[];
}

const ReferenceDocuments: React.FC<ReferenceDocumentsProps> = ({ documents }) => {
  return (
    <RepositCard flush title="Supporting Documents" tooltip="lorem">
      <Table>
        <Thead>
          <Tr>
            <Td>ID</Td>
            <Td>Name</Td>
            <Td>Type</Td>
            <Td>Uploaded At</Td>
            <Td>Action</Td>
          </Tr>
        </Thead>
        <Tbody>
          {documents &&
            documents.map(({ document }) => (
              <Tr key={document.id}>
                <Td>
                  <IdentifierValue>{document.id}</IdentifierValue>
                </Td>
                <Td>{truncateFilename(document.name)}</Td>
                <Td>{document.typeId}</Td>
                <Td>{moment(document.createdAt).format('DD/MM/YYYY HH:mm:ss')}</Td>
                <Td>
                  <A target="_blank" href={document.url}>
                    View
                  </A>
                </Td>
              </Tr>
            ))}
        </Tbody>
      </Table>
    </RepositCard>
  );
};

export default ReferenceDocuments;
